export const summaryTableTitle = 'Summary (All funnels)';
